import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { communityGroups } from "../../pages/CommunityPage";

const CommunityEventTemplate = () => {
  const { slug } = useParams();
  
  // Find the group using the unique slug
  const group = communityGroups.find(g => g.slug === slug);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

// Define your carousel images
const carouselImages = [
  group?.additionalImages?.[0],
  group?.additionalImages?.[1],
  group?.additionalImages?.[2],
  group?.additionalImages?.[3],
].filter(Boolean); // Remove any undefined/null values

// Auto-slide effect
useEffect(() => {
  const timer = setInterval(() => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
    );
  }, 3000); // Change image every 3 seconds

  return () => clearInterval(timer);
}, [carouselImages.length]);
  
  if (!group) {
    return <div className="p-8 text-center">No event found.</div>;
  }
  
  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:py-24 md:px-8">
  <div className="w-[85%] md:w-[85%] min-h-[75vh] md:max-h-[80vh] bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl shadow-2xl overflow-hidden mt-20 md:my-8">
    <div className="flex flex-col md:flex-row h-full w-full">
          {/* Image carousel - sticky on desktop only */}
          <div className="w-full md:w-1/2 md:sticky md:top-24 md:self-start h-[400px] md:h-[70vh]">
            <div className="w-full h-full md:h-[60vh] relative overflow-hidden rounded-r-[24px]">
              {carouselImages.map((image, index) => (
                <div
                  key={index}
                  className={`absolute top-0 left-0 w-full h-full transition-opacity duration-1000 ${
                    index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={image}
                    alt={`${group.title} event ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
              
              {/* Navigation dots */}
              <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2 z-10">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      index === currentImageIndex ? 'bg-white scale-125' : 'bg-white/50'
                    }`}
                    aria-label={`Go to image ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
          
          {/* Content area - scrollable */}
          <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col md:h-[calc(100vh-90px)] md:overflow-y-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-white">{group.title}</h1>
            <div 
              className="text-lg md:text-xl text-white/80 my-6"
              dangerouslySetInnerHTML={{ __html: group.detailedDescription }}
            />
            {group.additionalDetails && (
              <div className="space-y-4 text-white text-lg mt-6">
                <div className="flex items-center space-x-2">
                  <span className="font-semibold">Date:</span>
                  <span>{group.additionalDetails.date}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="font-semibold">Location:</span>
                  <span>{group.additionalDetails.location}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="font-semibold">Time:</span>
                  <span>{group.additionalDetails.time}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommunityEventTemplate;